// Invite / Revoke button for a team in a tournament, with its own spinner

import { useState } from 'react';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import { useModal } from './ModalProvider';
import { tournamentTeamUpdate } from '../utils/firebase';
import './TeamInviteButton.scss';

export default function TeamInviteButton({
  tournamentId,
  teamId,
  teamName,
  invited,
}) {
  const [loading, setLoading] = useState(false);
  const { openModal } = useModal();

  const setInvited = async (value) => {
    if (loading) return;

    try {
      setLoading(true);
      await tournamentTeamUpdate({
        id: tournamentId,
        team: teamId,
        invited: value,
      });
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message ??
          (value ? 'Failed to invite team' : 'Failed to revoke the invite'),
      );
    } finally {
      setLoading(false);
    }
  };

  const confirmRevoke = () => {
    openModal({
      header: 'Revoke invite',
      body: (
        <p className='font-16'>
          {`Are you sure you want to revoke the invite for `}
          <span className='font-medium'>{teamName}</span>
          {`?`}
          <br />
          {`The team will lose access to the tournament and will no longer be admitted.`}
        </p>
      ),
      buttons: [
        { text: 'Cancel', className: 'bw' },
        {
          text: 'Revoke',
          className: 'danger',
          onClick: () => setInvited(false),
        },
      ],
    });
  };

  const onClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading) return;
    if (invited) confirmRevoke();
    else setInvited(true);
  };

  return (
    <button
      className={
        'team-invite-button small' +
        (invited ? ' bw' : '') +
        (loading ? ' loading' : '')
      }
      aria-busy={loading}
      onClick={onClick}
    >
      <span className='label'>{invited ? 'Revoke' : 'Invite'}</span>
      {loading && (
        <span className='btn-spinner'>
          <ClipLoader size={12} color={invited ? '#3f90dc' : 'white'} loading />
        </span>
      )}
    </button>
  );
}
